import React from 'react';

export interface KPICardProps {
  title: string;
  value: string | number;
  delta?: {
    value: number;
    isPositive: boolean;
  };
  icon?: React.ReactNode;
  subtitle?: string;
  trend?: 'up' | 'down' | 'neutral';
  className?: string;
}

/**
 * Indicateur chiffré. Le chiffre est en Varela Round (comme les stats du site),
 * l'étiquette en capitales discrètes, la variation dans une petite pilule.
 */
const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  delta,
  icon,
  subtitle,
  className = '',
}) => {
  return (
    <div className={`bg-white dark:bg-gray-900 rounded-3xl border border-black/[0.08] dark:border-gray-800 p-5 ${className}`}>
      <div className="flex items-start justify-between gap-3">
        <p className="eyebrow pt-1">{title}</p>
        {icon && (
          <div className="w-10 h-10 -mt-1 -mr-1 rounded-full bg-cream-200 dark:bg-gray-800 text-brand-500 flex items-center justify-center flex-shrink-0 [&>svg]:w-5 [&>svg]:h-5">
            {icon}
          </div>
        )}
      </div>

      <div className="mt-3 flex items-end gap-2.5 flex-wrap">
        <p className="font-stat text-[1.75rem] leading-none text-gray-900 dark:text-gray-100">{value}</p>
        {delta && (
          <span
            className={`inline-flex items-center gap-1 h-6 px-2 rounded-full text-xs font-semibold mb-0.5 ${
              delta.isPositive
                ? 'bg-success-bg text-success'
                : 'bg-brand-50 text-brand-600'
            }`}
          >
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              {delta.isPositive
                ? <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
                : <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />}
            </svg>
            {Math.abs(delta.value)}%
          </span>
        )}
      </div>

      {subtitle && (
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>
      )}
    </div>
  );
};

export default KPICard;
